import { ImagesApp } from './images';

type CardsInfoType = {
  [key: string]: {
    name: string;
    logo: string;
  };
}

export const CardsInfo: CardsInfoType = {
  hipercard : {
    name : 'Hipercard',
    logo : ImagesApp.svg.hipercard,
  },
  elo : {
    name : 'Elo',
    logo : ImagesApp.svg.elo,
  },
  discover : {
    name : 'Discover',
    logo : ImagesApp.svg.discover,
  },
  dinersclub : {
    name : 'Diners Club',
    logo : ImagesApp.svg.dinersclub,
  },
  amex : {
    name : 'American Express',
    logo : ImagesApp.svg.amex,
  },
  jcb : {
    name : 'JCB',
    logo : ImagesApp.svg.jcb,
  },
  visa : {
    name : 'Visa',
    logo : ImagesApp.svg.visa,
  },
  maestro : {
    name : 'Maestro',
    logo : ImagesApp.svg.maestro,
  },
  mastercard : {
    name : 'Mastercard',
    logo : ImagesApp.svg.mastercard,
  },
};
